import type { IPublication } from '@pressreader/catalog-types';
import { httpGet } from '@pressreader/services';

import { mapPublicationFromDto } from './mappers';
import type { IPublicationDto } from './types';

/**
 * Single-publication fetch, reached on the eager boot path: `publication-common`'s load-publication
 * saga resolves a publication by CID behind the navigation provider.
 *
 * Kept in a leaf module with only eager-safe dependencies (the HTTP layer and this lib's DTO
 * mappers): anything this file imports ships in the eager `app` bundle alongside it, so the
 * publications list query in `./service.ts` — and the filter mapping and page-size constant it
 * pulls in — stays out.
 */

export function getPublicationDTO(cid: string): Promise<IPublicationDto> {
    return httpGet('catalog/v2', `publications/${cid}`);
}

export async function getPublicationByCID(cid: string): Promise<IPublication> {
    const publicationDTO = await getPublicationDTO(cid);
    return mapPublicationFromDto(publicationDTO);
}
